export const getOrCreateTooltip = (chart: any) => {
  let tooltipEl = chart.canvas.parentNode.querySelector('div');

  if (!tooltipEl) {
    tooltipEl = document.createElement('div');
    tooltipEl.style.background = 'rgba(0, 0, 0, 0.7)';
    tooltipEl.style.borderRadius = '3px';
    tooltipEl.style.color = 'white';
    tooltipEl.style.opacity = 1;
    // tooltipEl.style.pointerEvents = 'none';
    tooltipEl.style.position = 'absolute';
    tooltipEl.style.transform = 'translate(-50%, 0)';
    tooltipEl.style.transition = 'all .1s ease';

    const table = document.createElement('table');
    table.style.margin = '0px';

    tooltipEl.appendChild(table);
    chart.canvas.parentNode.appendChild(tooltipEl);
  }

  return tooltipEl;
};

export const externalTooltipHandler = (context: any, navigateToAssessment: Function, baseComponentRef: any) => {
  // Tooltip Element
  const { chart, tooltip } = context;
  const tooltipEl = getOrCreateTooltip(chart);

  // console.log('tooltip.opacity', tooltip.opacity);
  // console.log('chris baseComponentRef.chart', baseComponentRef.chart);
  //   baseComponentRef.chart.tooltip?.setActiveElements([], { x: 0, y: 0 });

  // Hide if no tooltip
  if (tooltip.opacity === 0) {
    tooltipEl.style.opacity = 0;
    return;
  }

  // Set Text
  if (tooltip.body) {
    const titleLines = tooltip.title || [];
    const bodyLines = tooltip.body.map((b: any) => b.lines);

    const tableHead = document.createElement('thead');

    titleLines.forEach((title: any) => {
      const tr = document.createElement('tr');
      tr.style.borderWidth = '0';

      const th = document.createElement('th');
      th.style.borderWidth = '0';
      const text = document.createTextNode(title);

      th.appendChild(text);
      tr.appendChild(th);
      tableHead.appendChild(tr);
    });

    const tableBody = document.createElement('tbody');
    bodyLines.forEach((body: any, i: any) => {
      const colors = tooltip.labelColors[i];

      const span = document.createElement('span');
      span.style.background = colors.backgroundColor;
      span.style.borderColor = colors.borderColor;
      span.style.borderWidth = '2px';
      span.style.marginRight = '10px';
      span.style.height = '10px';
      span.style.width = '10px';
      span.style.display = 'inline-block';

      const tr = document.createElement('tr');
      tr.style.backgroundColor = 'inherit';
      tr.style.borderWidth = '0';

      const td = document.createElement('td');
      td.style.borderWidth = '0';

      const text = document.createTextNode(body);

      td.appendChild(span);
      td.appendChild(text);
      tr.appendChild(td);
      tableBody.appendChild(tr);
    });

    const tableRoot = tooltipEl.querySelector('table');

    // Remove old children
    while (tableRoot.firstChild) {
      tableRoot.firstChild.remove();
    }

    // Add new children
    tableRoot.appendChild(tableHead);
    tableRoot.appendChild(tableBody);

    // Add link
    const button = document.createElement('button');
    button.textContent = 'Testung bearbeiten';
    button.style.marginTop = '20px';
    button.onclick = function () {
      console.log('click context', context);
      console.log('click score', tooltip.dataPoints[0].raw.score);
      console.log('click documentId', tooltip.dataPoints[0].raw.documentId);
      console.log('click assessmentType', tooltip.dataPoints[0].raw.assessmentType);
      const assessmentType = tooltip.dataPoints[0].raw.assessmentType;
      const documentId = tooltip.dataPoints[0].raw.documentId;
      navigateToAssessment.call(baseComponentRef, assessmentType, documentId);
    };
    tableRoot.appendChild(button);
  }

  const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas;

  // Display, position, and set styles for font
  tooltipEl.style.opacity = 1;
  tooltipEl.style.left = positionX + tooltip.caretX + 'px';
  tooltipEl.style.top = positionY + tooltip.caretY + 'px';
  tooltipEl.style.font = tooltip.options.bodyFont.string;
  tooltipEl.style.padding = tooltip.options.padding + 'px ' + tooltip.options.padding + 'px';
};

// --------------
// X-axis labels

export const findLabel = (labels: any, evt: any) => {
  let found = false;
  let res = null;
  labels.forEach((label: any) => {
    if (evt.x > label.x && evt.x < label.x2 && evt.y > label.y && evt.y < label.y2) {
      res = {
        label: label.label,
        index: label.index,
      };
      found = true;
    }
  });
  return [found, res];
};
export const getLabelHitBoxes = (x: any) => {
  return x._labelItems.map((e: any, i: any) => ({
    x: e.options.translation[0] - x._labelSizes.widths[i],
    x2: e.options.translation[0] + x._labelSizes.widths[i] / 2,
    y: e.options.translation[1] - x._labelSizes.heights[i] / 2,
    y2: e.options.translation[1] + x._labelSizes.heights[i] / 2,
    label: e.label,
    index: i,
  }));
};

export function splitTextByMaxChars(text: string, maxChars: number) {
  const result = [];
  const lines = text.split('\n'); // Text zuerst nach Zeilenumbrüchen aufteilen

  for (let line of lines) {
    let startIndex = 0;

    while (startIndex < line.length) {
      let endIndex = startIndex + maxChars;

      // Sicherstellen, dass endIndex nicht über das Zeilenende hinausgeht
      if (endIndex >= line.length) {
        result.push(line.slice(startIndex).trim());
        break;
      }

      // Prüfen, ob das Zeichen am endIndex ein Leerzeichen ist
      if (line[endIndex] !== ' ') {
        // Finde das letzte Leerzeichen innerhalb des Bereichs maxChars
        endIndex = line.lastIndexOf(' ', endIndex);
        if (endIndex <= startIndex) {
          // Wenn kein Leerzeichen gefunden wird, schneiden wir bei maxChars ab
          endIndex = startIndex + maxChars;
        }
      }

      // Teilstring hinzufügen und Leerzeichen entfernen
      result.push(line.slice(startIndex, endIndex).trim());

      // Startindex auf das nächste Zeichen nach endIndex setzen
      startIndex = endIndex + 1;
    }
  }

  return result;
}

// Das Plugin zum Highlighten eines Bereichs
export const highlightPlugin = {
  id: 'highlightPlugin',
  afterDatasetsDraw(chart: any, args: any, options: any) {
    const {
      ctx,
      data,
      chartArea: { top, bottom },
      scales: { x },
    } = chart;

    // Der Index und die Breite des Highlights (von den Plugin-Optionen)
    const highlightIndex = options.highlightIndex ?? -1;
    const highlightWidth = options.highlightWidth ?? 20;
    const date = new Date(data.datasets[0].data[highlightIndex].x);
    // const date = new Date(data.labels[highlightIndex]);

    // Achtung: da wir die x-achse mit ALLEN Datumsen aus allen Assessments gefüttert haben, müssen wir jetzt den index matchen

    if (highlightIndex >= 0) {
      // X-Position des markierten Punktes
      const xPos = x.getPixelForValue(date); // achtung: getPixelForValue will nicht den index, es will WERT, also x-achse -> Datum!
      // console.log('chris ', { highlightIndex, date, labels: data.labels, data, xPos });

      // Graue Box zeichnen
      ctx.save();
      ctx.fillStyle = options.color ?? 'rgba(128, 128, 128, 0.3)';
      ctx.fillRect(xPos - highlightWidth / 2, top, highlightWidth, bottom - top);
      ctx.restore();
    }
  },
};
